var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"bb7beede594c1d4e1c998889ecd71d9f830f395d"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

import { getSentryConfig } from './src/utils/getSentryConfig';

const monitoredEnvs = ['dev', 'int', 'esg', 'esg-2', 'esg-3', 'prod'];
const isMonitored = monitoredEnvs.includes(process.env.APP_STAGE);

// Disable Sentry in feature environments
if (isMonitored) {
  Sentry.init(getSentryConfig());
}
